export default "__VITE_ASSET__22038de0__"